import { cAPI } from '../../../utils/cAPI';
import { getData, addEditData } from '../generic';

export const getTranslations = () => dispatch => getData(dispatch, cAPI.APGetTranslations, null, 'translations');
export const updateTranslations = formData => dispatch => addEditData(dispatch, cAPI.APUpdateTranslations, formData, 'translations');

